import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import validator from "validator";

import { Modal, Button, TextArea, TextInput } from "ui/elements";

import { send } from "store/testDrives/actions";

class TestDriveModal extends Component {
  state = {
    lastName: "",
    firstName: "",
    email: "",
    emailConfirm: "",
    phone: "",
    message: "",
    overage: true,
    privacy: false,
  };

  isValid() {
    return [
      !validator.isEmpty(this.state.lastName),
      !validator.isEmpty(this.state.firstName),
      !validator.isEmpty(this.state.email) &&
        validator.isEmail(this.state.email),
      !validator.isEmpty(this.state.emailConfirm) &&
        this.state.email === this.state.emailConfirm,
      this.state.privacy,
    ].every((isValid) => isValid);
  }

  renderContent() {
    return (
      <div className="uk-grid uk-grid-medium">
        <div className="uk-width-1-3@s">
          <div className="information">
            <p>Ti contatteremo al più presto per fissare un appuntamento.</p>
            <p>
              Se lo desideri, un trainer qualificato ti guiderà gratuitamente in
              un allenamento in sala attrezzi personalizzato sulla base delle
              tue esigenze.
            </p>
            <p>È possibile provare il centro una sola volta.</p>
            <p>
              <strong>
                La giornata di prova è gratuita e non comporta nessun impegno.
              </strong>
            </p>
          </div>
        </div>
        <div className="uk-width-2-3@s">
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                placeholder="cognome"
                value={this.state.lastName}
                onChange={(lastName) => this.setState({ lastName })}
              />
            </div>
            <div>
              <TextInput
                placeholder="nome"
                value={this.state.firstName}
                onChange={(firstName) => this.setState({ firstName })}
              />
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                type="email"
                placeholder="e-mail"
                value={this.state.email}
                onChange={(email) => this.setState({ email })}
              />
              {this.state.email !== "" &&
                !validator.isEmail(this.state.email) && (
                  <p className="uk-text-danger uk-text-small uk-margin-small-top">
                    questo indirizzo e-mail non sembra valido...
                  </p>
                )}
            </div>
            <div>
              <TextInput
                type="email"
                placeholder="conferma e-mail"
                value={this.state.emailConfirm}
                onChange={(emailConfirm) => this.setState({ emailConfirm })}
              />
              {this.state.email !== "" &&
                this.state.email !== this.state.emailConfirm && (
                  <p className="uk-text-danger uk-text-small uk-margin-small-top">
                    le e-mail non coincidono...
                  </p>
                )}
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-2@s">
            <div>
              <TextInput
                placeholder="telefono"
                value={this.state.phone}
                onChange={(phone) => this.setState({ phone })}
              />
            </div>
            <div className="uk-flex uk-flex-middle">
              <label className="uk-flex uk-flex-middle">
                <input
                  type="checkbox"
                  checked={this.state.overage}
                  onChange={() =>
                    this.setState({ overage: !this.state.overage })
                  }
                />{" "}
                <span className="uk-inline-block uk-margin-small-left">
                  Sono maggiorenne
                </span>
              </label>
            </div>
          </div>
          <div className="uk-grid uk-grid-small uk-child-width-1-1">
            <div>
              <TextArea
                placeholder="messaggio"
                value={this.state.message}
                onChange={(message) => this.setState({ message })}
                rows="5"
              />
            </div>
          </div>
          <div className="uk-grid uk-grid-medium">
            <div className="uk-width-1-1">
              <input
                type="checkbox"
                checked={this.state.privacy}
                onChange={() => this.setState({ privacy: !this.state.privacy })}
              />{" "}
              Acconsento al trattamento dei miei dati personali come da{" "}
              <Link to="/privacy-policy" target="_blank">
                informativa sulla privacy
              </Link>
            </div>
          </div>
          <div className="actions uk-text-center">
            <Button
              disabled={!this.isValid()}
              onClick={() => this.props.send(this.state)}
            >
              Prenota
            </Button>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, success } = this.props;

    let content = null;
    if (!loading) {
      if (error) {
        content = (
          <div className="uk-alert uk-alert-danger uk-padding uk-text-center">
            <p>
              <strong>Errore</strong>
              <br />
              Si è verificato un errore nell'invio della tua richiesta.
              <br />
              Prova nuovamente più tardi o scrivici all'indirizzo
              info@youcanfitnessfactory.it.
            </p>
          </div>
        );
      } else {
        if (success) {
          content = (
            <div className="uk-alert uk-alert-success uk-padding uk-text-center">
              <p>
                <strong>Richiesta inviata</strong>
                <br />
                La tua richiesta è stata inviata correttamente. Verrai
                ricontattato al più presto da un responsabile.
              </p>
              <p>
                <i className="fa fa-spinner fa-spin fa-3x" />
              </p>
            </div>
          );
        } else {
          content = this.renderContent();
        }
      }
    } else {
      content = (
        <div className="uk-padding-large uk-text-center">
          <i className="fa fa-spinner fa-spin fa-3x" />
        </div>
      );
    }

    return (
      <Modal className="test-drive-modal" name="test-drive-modal">
        <h2>Prenota una prova gratuita</h2>
        {content}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({ ...state.testDrives });
const mapDispatchToProps = (dispatch) => ({
  send: (info) => dispatch(send(info)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TestDriveModal);



// WEBPACK FOOTER //
// ./src/ui/components/TestDriveModal.js